import React, { useEffect, useState } from 'react';
import { DataCell, CommonModal } from '../../TableUIKit';
import { useWaApi } from '../../auth/helper/api/waApi';
import { useUserProfileAccess } from '../../auth/helper/useUserProfileAccess';
import { validateRequiredFields } from "../../utils/formValidation";
import { validateHeaderVariables } from "../../utils/formValidation";
import { validateBodyVariables } from "../../utils/formValidation";
import { validateButtonVariables } from "../../utils/formValidation";
import { validateTemplateName } from "../../utils/formValidation";
import { deepTrim } from "../../utils/formValidation";
import { extractVariables } from "../../utils/formValidation";

const WaTemplatePage = () => {

  const waApi = useWaApi();
  // Only a SYSTEM_ADMIN or ADMIN may change anything here; a USER gets a read-only view. The service refuses
  // the writes too, so this just keeps the controls out of sight.
  const { canManageWhatsAppSetup } = useUserProfileAccess();


  const [templates, setTemplates] = useState([]);
  const [categories, setCategories] = useState([]); // State for categories
  const [wabas, setWabas] = useState([]); // State for WABA list
  const [viewMode, setViewMode] = useState('create'); // 'create' or 'view'
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formError, setFormError] = useState({});
  const [actionErrors, setActionErrors] = useState({});
  const [createError, setCreateError] = useState(null);
  const [createMessage, setCreateMessage] = useState(null);
  const [syncingTemplateId, setSyncingTemplateId] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deletingTemplateId, setDeletingTemplateId] = useState(null);

  const clearMessages = () => {
    setCreateError(null);
    setCreateMessage(null);
    setActionErrors({});
    setFormError({});
  };

  // State for filters
  const initialFilters = {
    id: null,
    waTemplateId: null,
    waTemplateName: null,
    waTemplateStatus: null,
    waTemplateStage: null,
    waTemplateCategory: null,
  };
  const [filters, setFilters] = useState(initialFilters);

  const resetFilters = () => {
    clearMessages();
    setFilters(initialFilters);
  };

  //for handling pagination
  const [page, setPage] = useState(0); // Starting from the first page
  const [size, setSize] = useState(3); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // To store total pages

  const [activeDetails, setActiveDetails] = useState(null);

  ///add start
  const headerComponent = {
    type: "header",
    format: "", //text|image|document|location|video
    text: "",
    example: {
      header_text: [], //if type is text
      header_handle: ["4::aW..."] //if format is |image|document|video
    }
  };
  const bodyComponent = {
    type: "body",
    text: "",
    add_security_recommendation: false,
    example: {
      body_text: [[]],
    }
  };
  const footerComponent = {
    type: "footer",
    text: "",
    code_expiration_minutes: 5
  };
  const buttonBody = {
    type: "", //otp|phone|url|QUICK_REPLY
    text: "",
    otp_type: "",//ONE_TAP|COPY_CODE
    phone_number: "",
    url: "",
    example: ["code2025"]
  }
  const buttonComponent = {
    type: "buttons",
    buttons: [JSON.parse(JSON.stringify(buttonBody))]
  };
  const initialTemplateForm = {
    name: "",
    language: "en",
    category: "",
    wabaId: "",
    parameter_format: "POSITIONAL",
    library_template_name: "",
    message_send_ttl_seconds: "",
    // Use structuredClone for deep-copying initial component structures
    components: [
      structuredClone(headerComponent),
      structuredClone(bodyComponent),
      structuredClone(footerComponent),
      structuredClone(buttonComponent)
    ]
  };
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [templateForm, setTemplateForm] = useState({
    name: "",
    language: "en",
    category: "",
    wabaId: "",
    parameter_format: "POSITIONAL",
    library_template_name: "",
    message_send_ttl_seconds: "",
    components: [JSON.parse(JSON.stringify(headerComponent))
      , JSON.parse(JSON.stringify(bodyComponent))
      , JSON.parse(JSON.stringify(footerComponent))
      , JSON.parse(JSON.stringify(buttonComponent))]
  });

  const [editingTemplate, setEditingTemplate] = useState(null); // Track which tempalte is being edited
  const [editSmsTemplateStage, setEditSmsTemplateStage] = useState("");
  const [editingTemplateId, setEditingTemplateId] = useState(null);


  /* ===== Helpers ===== */
const updateComponent = (index, field, value) => {
  const updated = [...templateForm.components];

  updated[index][field] = value;

  // Header format validation
  if (index === 0 && field === "format") {
    if (value !== "TEXT") {
      updated[0].text = "";
      updated[0].example.header_text = [];
    }
  }

  setTemplateForm({
    ...templateForm,
    components: updated
  });
};

  /* ===== Header Variables ===== */
const addHeaderText = () => {
  const updated = [...templateForm.components];

  // Allow only one variable
  if (updated[0].example.header_text.length === 0) {
    updated[0].example.header_text.push("");
  }

  setTemplateForm({
    ...templateForm,
    components: updated
  });
};

  const updateHeaderText = (i, value) => {
    const updated = [...templateForm.components];
    updated[0].example.header_text[i] = value;
    setTemplateForm({ ...templateForm, components: updated });
  };

  const deleteHeaderText = (i) => {
    const updated = [...templateForm.components];
    updated[0].example.header_text.splice(i, 1);
    setTemplateForm({ ...templateForm, components: updated });
  };

  /* ===== Body Variables ===== */
  const addBodyText = () => {
    const updated = [...templateForm.components];
    updated[1].example.body_text[0].push("");
    setTemplateForm({ ...templateForm, components: updated });
  };

  const updateBodyText = (i, value) => {
    const updated = [...templateForm.components];
    updated[1].example.body_text[0][i] = value;
    setTemplateForm({ ...templateForm, components: updated });
  };

  const deleteBodyText = (i) => {
    const updated = [...templateForm.components];
    updated[1].example.body_text[0].splice(i, 1);
    setTemplateForm({ ...templateForm, components: updated });
  };

  /* ===== Buttons ===== */
  /* ===== Buttons ===== */
  const BUTTON_LIMITS = {
    OTP: 1,
    PHONE_NUMBER: 1,
    URL: 2,
    QUICK_REPLY: 10
  };

  const BUTTON_ORDER = {
    OTP: 1,
    PHONE_NUMBER: 2,
    URL: 3,
    QUICK_REPLY: 4
  };

  const sortButtons = (buttons) => {
    return [...buttons].sort(
      (a, b) => BUTTON_ORDER[a.type] - BUTTON_ORDER[b.type]
    );
  };

const addButton = () => {
  const updated = [...templateForm.components];

  const buttons = updated[3].buttons;

  if (buttons.length >= 10) {
    alert("Maximum 10 buttons allowed");
    return;
  }

  buttons.push(structuredClone(buttonBody));

  setTemplateForm({
    ...templateForm,
    components: updated
  });
};

const updateButton = (index, field, value) => {
  const updated = [...templateForm.components];
  const buttons = updated[3].buttons;

  if (field === "type") {

    const currentType = buttons[index].type;

    if (currentType !== value) {

      const count = buttons.filter(
        (btn, idx) =>
          idx !== index &&
          btn.type === value
      ).length;

      const maxAllowed = BUTTON_LIMITS[value] || 10;

      if (count >= maxAllowed) {
        alert(`Only ${maxAllowed} ${value} button(s) allowed`);
        return;
      }

      buttons[index] = {
        ...structuredClone(buttonBody),
        type: value
      };
    }
  }

  // if (field === "url") {

  //   const matches = value.match(/\{\{\d+\}\}/g) || [];

  //   if (matches.length > 1) {
  //     alert("URL button supports only one dynamic variable");
  //     return;
  //   }
  // }

  buttons[index][field] = value;

  updated[3].buttons = sortButtons(buttons);

  setTemplateForm({
    ...templateForm,
    components: updated
  });
};

const deleteButton = (index) => {
  const updated = [...templateForm.components];

  updated[3].buttons.splice(index, 1);

  setTemplateForm({
    ...templateForm,
    components: updated
  });
};

  const TEMPLATE_STAGES = new Set([
    "PENDING",
    "IN_REVIEW",
    "APPROVED",
    "REJECTED",
    "PAUSED",
    "DISABLED",
    "PENDING_DELETION"
  ]);
  // "PENDING",
  // "APPROVED",
  // "ACTIVE",
  // "REJECTED",
  // "PAUSED",
  // "DISABLED",
  // "APPEAL_REQUESTED",
  // "APPEAL",
  // "FLAGGED",
  // "REINSTATED",
  // "QUALITY_PENDING",
  // "HIGH_QUALITY",
  // "MEDIUM_QUALITY",
  // "LOW_QUALITY"

  ///add ends


  const fetchTemplates = async () => {
    try {
      const cleanedFilters = Object.fromEntries(
        Object.entries(filters).map(([key, value]) => [
          key,
          value === '' ? null : value,
        ])
      );
      // Replace with your actual API endpoint
      const response = await waApi.get(
        process.env
          .REACT_APP_GET_ALL_WA_TEMPLATES_BY_PAGE_ENDPOINT,
        {
          params: {
            ...cleanedFilters,
            page,
            size,
          },
        }
      );

      // Extract data from the response
      const { message, object, httpStatus } = response.data;
      if (httpStatus === 200) { // Check for successful status
        setTemplates(object.content); // Set the templates from the response object
        setTotalPages(object.totalPages);
      } else {
        setError(`Error: ${message}`); // Handle non-success status code
      }

      setLoading(false);
    } catch (err) {
      console.error('Error fetching templates:', err);
      setError(err.message || 'An unexpected error occurred.'); // Provide error message to state
      setLoading(false);
    }
  };

  useEffect(() => {

    const fetchCategories = async () => {

      try {
        const response = await waApi.get(
          process.env
            .REACT_APP_GET_ALL_WA_CATEGORIES_ENDPOINT
        );

        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setCategories(object); // Set the templates from the response object
          console.log('categories:', categories);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }
        setLoading(false);

      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err.message || 'Failed to load categories.');
        setLoading(false);
      }
    };
    const fetchWabas = async () => {

      try {
        const response = await waApi.get(
          process.env
            .REACT_APP_GET_ALL_WABA_DETAILS_ENDPOINT
        );

        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setWabas(object); // Set the wabas from the response object
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }
        setLoading(false);

      } catch (err) {
        console.error('Error fetching wabas:', err);
        setError(err.message || 'Failed to load wabas.');
        setLoading(false);
      }
    };
    fetchTemplates();
    fetchCategories();
    fetchWabas();
  }, [waApi, page, size]);

  useEffect(() => {
    if (modalOpen) {
      setFormError({});
    }
  }, [modalOpen]);

  const handleCreateNew = () => {
    clearMessages();
    setViewMode('create');
    setEditingTemplateId(null);
    setTemplateForm({
      ...initialTemplateForm,
      // Deep clone again to ensure the reset state is a fresh copy
      components: [
        structuredClone(headerComponent),
        structuredClone(bodyComponent),
        structuredClone(footerComponent),
        structuredClone(buttonComponent)
      ]
    });
    setModalOpen(true); // Close modal after submission
  };
  // A saved template (and one synced from Meta) lists only the components it has, in Meta's order, with an
  // upper- or lower-case type. The form works on four fixed slots - header, body, footer, buttons - so rebuild
  // them by type, fill a missing slot from the empty defaults, and give the header and body the "example"
  // parts the form reads. An example only belongs to a {{n}} placeholder (the same test the form's validators use):
  // text without one gets no example, with or without a stale one saved. A component of any other type is kept
  // after the four slots, untouched.
  const withFormComponents = (waTemplate) => {
    const form = structuredClone(waTemplate);
    const saved = Array.isArray(form.components) ? form.components : [];
    const FORM_TYPES = ["header", "body", "footer", "buttons"];
    const typeOf = (c) => String(c?.type ?? "").toLowerCase();
    const take = (type, empty) => saved.find((c) => typeOf(c) === type) ?? structuredClone(empty);

    const header = take("header", headerComponent);
    const headerHasVariable = extractVariables(header.text ?? "").length > 0;
    header.example = { ...header.example, header_text: headerHasVariable ? (header.example?.header_text ?? []) : [] };

    const body = take("body", bodyComponent);
    const bodyHasVariable = extractVariables(body.text ?? "").length > 0;
    const bodyText = body.example?.body_text;
    body.example = {
      ...body.example,
      body_text: bodyHasVariable && Array.isArray(bodyText) && Array.isArray(bodyText[0]) ? bodyText : [[]]
    };

    const footer = take("footer", footerComponent);
    const buttons = take("buttons", buttonComponent);
    if (!Array.isArray(buttons.buttons) || buttons.buttons.length === 0) {
      buttons.buttons = [structuredClone(buttonBody)];
    }

    form.components = [header, body, footer, buttons, ...saved.filter((c) => !FORM_TYPES.includes(typeOf(c)))];
    return form;
  };

  const handleEditClick = (template) => {
    clearMessages();
    setViewMode('edit');
   // setTemplateForm(structuredClone(template.waTemplate));
    setTemplateForm({
      ...withFormComponents(template.waTemplate),
      wabaId: template.wabaId
    });
    setEditingTemplateId(template.id);
    setModalOpen(true); // Open modal after submission

  };

  const handleEditSubmit = async (templateId) => {

  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    clearMessages();
    console.log("FINAL TEMPLATE", templateForm);
    //validation begins
    const validation = validateRequiredFields({
      category: {
        value: templateForm.category,
        label: "Category"
      },
      wabaId: {
        value: templateForm.wabaId,
        label: "WABA"
      },
      bodyText: {
        value: templateForm.components[1].text,
        label: "Body Text"
      }
    });
    const templateNameError = validateTemplateName(templateForm.name);
    const errors = {
      ...validation.errors,
      ...(templateNameError ? { templateName: templateNameError } : {}),
      ...validateHeaderVariables(templateForm.components[0]),
      ...validateBodyVariables(templateForm.components[1]),
      ...validateButtonVariables(templateForm.components[3])
    };
    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      return;
    }
    //validation ends
    //const response = null;
    const trimmedPayload = deepTrim(templateForm);
    try {
      if (viewMode === 'create') {
        console.log("\n------start-create----\n" + JSON.stringify(trimmedPayload, null, 2) + "\n-----end-create------\n");
        try {
          const response = await waApi.post(
            `${process.env.REACT_APP_SET_WA_TEMPLATE_ENDPOINT}/${trimmedPayload.wabaId}`, trimmedPayload);
          setCreateMessage(response.data.message);
          fetchTemplates();
        } catch (err) {
          setCreateError(err.message || 'An error occurred while creating the template.');
        }
      }
      if (viewMode === 'edit') {
        console.log("\n------Begin-edit----\n" + JSON.stringify(trimmedPayload, null, 2) + "\n-----End-edit-----\n")
        try {
          const response = await waApi.put(
            `${process.env.REACT_APP_PUT_WA_TEMPLATE_ENDPOINT}/${trimmedPayload.wabaId}`, trimmedPayload);
          setTemplates((prev) => prev.map(template =>
            template.id === response.data.object.id ? response.data.object : template
          ));
          setCreateMessage(response.data.message);
        } catch (err) {
          setActionErrors((prev) => ({ ...prev, [editingTemplateId]: err.message || 'An error occurred while updating the template.' }));
        }
      }
    } finally {
      setTemplateForm({
        ...initialTemplateForm,
        // Deep clone again to ensure the reset state is a fresh copy
        components: [
          structuredClone(headerComponent),
          structuredClone(bodyComponent),
          structuredClone(footerComponent),
          structuredClone(buttonComponent)
        ]
      });
      setEditingTemplateId(null);
      setModalOpen(false); // Close modal after submission
    }
  };

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      return newFilters;
    });
  };

  // Handle the status change to convert to boolean
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const statusValue = value === 'Active' ? true : value === 'Inactive' ? false : null;

    setFilters((prev) => {
      const newFilters = { ...prev, waTemplateStatus: statusValue };
      return newFilters;
    });
  };

  const refreshCache = async () => {
    clearMessages();
    try {
      const response = await waApi.get(
        process.env.REACT_APP_REFRESH_WA_TEMPLATE_CACHE_ENDPOINT
      );
      if (response.data.httpStatus === 200) {
        setCreateMessage(response.data.message);
      } else {
        setCreateError(response.data.message);
      }
    } catch (err) {
      setCreateError(err.message || 'An error occurred while refreshing the cache.');
    }
  };

  const toggleActivationStatus = async (templateId, currentStatus) => {
    clearMessages();
    try {
      const newStatus = !currentStatus; // Toggle activation status
      const response = await waApi.patch(
        `${process.env.REACT_APP_SET_WA_TEMPLATE_STATUS_ENDPOINT}/${templateId}`,
        { status: newStatus }
      );
      setTemplates((prev) => prev.map(template =>
        template.id === templateId ? { ...template, waTemplateStatus: newStatus } : template
      ));
      setCreateMessage(response.data.message);
    } catch (err) {
      setActionErrors((prev) => ({ ...prev, [templateId]: err.message || 'An error occurred while updating the status.' }));
    }
  };

  const handleSyncTemplate = async (template) => {
    clearMessages();
    setSyncingTemplateId(template.id);
    try {
      const response = await waApi.get(
        `${process.env.REACT_APP_SYNC_WA_TEMPLATE_ENDPOINT}/${template.wabaId}/${template.waTemplateId}`
      );
      setCreateMessage(response.data.message);
      fetchTemplates();
    } catch (err) {
      setActionErrors((prev) => ({ ...prev, [template.id]: err.message || 'An error occurred while syncing the template with wa.' }));
    } finally {
      setSyncingTemplateId(null);
    }
  };

  const handleDeleteClick = (template) => {
    clearMessages();
    setDeleteTarget(template);
  };

  const handleDeleteCancel = () => {
    setDeleteTarget(null);
  };

  const performDelete = async (includeId) => {
    if (!deleteTarget) return;
    clearMessages();
    setDeletingTemplateId(deleteTarget.id);
    try {
      const params = includeId
        ? { id: deleteTarget.id, templateName: deleteTarget.waTemplateName, templateId: deleteTarget.waTemplateId }
        : { templateName: deleteTarget.waTemplateName, templateId: deleteTarget.waTemplateId };
      const response = await waApi.delete(
        `${process.env.REACT_APP_DELETE_WA_TEMPLATE_ENDPOINT}/${deleteTarget.wabaId}`,
        { params }
      );
      setTemplates((prev) => prev.map((t) =>
        t.id === deleteTarget.id ? { ...t, waTemplateStatus: Boolean(response.data.object) } : t
      ));
      setCreateMessage(response.data.message);
    } catch (err) {
      setActionErrors((prev) => ({ ...prev, [deleteTarget.id]: err.message || 'An error occurred while deleting the template.' }));
    } finally {
      setDeletingTemplateId(null);
      setDeleteTarget(null);
    }
  };

  const handleSoftDelete = () => performDelete(true);
  const handleHardDelete = () => performDelete(false);

  // New function to apply filters
  const applyFilters = async (pageParam) => {

    setLoading(true); // Show loading while fetching filtered notifications
    clearMessages();
    var hitApplyFilter = null;
    if(page === 0) {
      hitApplyFilter = true;
    } else {
      hitApplyFilter = false;
    }
    if(pageParam===0) {
      setPage(0);
    }
    if(hitApplyFilter) {
      try {
        const cleanedFilters = Object.fromEntries(
          Object.entries(filters).map(([key, value]) => [
            key,
            value === '' ? null : value,
          ])
        );
        const response = await waApi.get(
          process.env
            .REACT_APP_GET_ALL_WA_TEMPLATES_BY_PAGE_ENDPOINT,
          {
            params: {
              ...cleanedFilters,
              page,
              size,
            },
          }
        );

       // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setTemplates(object.content); // Set the templates from the response object
          setTotalPages(object.totalPages);
        } else {
          setCreateError(message); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching templates:', err);
        setCreateError(err.message || 'An unexpected error occurred.'); // Provide error message to state
        setLoading(false);
      }
  }
  };

  const handleNextPage = () => {
    clearMessages();
    if (page + 1 < totalPages) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  const handlePreviousPage = () => {
    clearMessages();
    if (page > 0) {
      setPage((prevPage) => prevPage - 1); // Decrement page number
    }
  };

  const handleSizeChange = (e) => {
    clearMessages();
    setSize(e.target.value);
    setPage(0); // Reset to first page on changing size
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading templates: {error}</div>;

  return (

    <div className="page-container">
        <h1>App Templates</h1>
        <div className="flex-row filter-section">
          <div className='filter-item'>
            <label htmlFor="items-per-page">Items per page: </label>
            <select id="items-per-page" onChange={handleSizeChange} className="w-auto">
              <option value={3}>default</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={5}>5</option>
              <option value={10}>10</option>
            </select>
          </div>
        </div>

        <h3>Filters</h3>
        {/* Filter Form */}
        <div className="flex-row filter-section">
          <div className="filter-item">
            <label>Primary ID:</label>
            <input
              type="text"
              name="id"
              value={filters.id ?? ''}
              onChange={handleFilterInputChange}
              placeholder="Only numeric value"
            />
          </div>

          <div className="filter-item">
            <label>Template ID:</label>
            <input
              type="text"
              name="waTemplateId"
              value={filters.waTemplateId ?? ''}
              onChange={handleFilterInputChange}
            />
          </div>

          <div className="filter-item">
            <label>Template Name:</label>
            <input
              type="text"
              name="waTemplateName"
              value={filters.waTemplateName ?? ''}
              onChange={handleFilterInputChange}
            />
          </div>

          <div className="filter-item">
            <label>Status:</label>
            <select name="waTemplateStatus" onChange={handleStatusChange} value={filters.waTemplateStatus === null ? '' : filters.waTemplateStatus ? 'Active' : 'Inactive'}>
              <option value="">All</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div className="filter-item">
            <label>Template Stage:</label>
            <select name="waTemplateStage" onChange={handleFilterInputChange} value={filters.waTemplateStage ?? ''}>
              <option value="">All</option>
              {[...TEMPLATE_STAGES]?.map((stage, index) => (
                <option key={index} value={stage}>
                  {stage}
                </option>
              ))}
           </select>
          </div>

           <div className="filter-item">
          <label>Template Category:</label>
          <select name="waTemplateCategory" onChange={handleFilterInputChange} value={filters.waTemplateCategory ?? ''}>
            <option value="">All</option>
            {categories?.map((waTemplateCategory, index) => (
              <option key={index} value={waTemplateCategory.templateCategory}>
                {waTemplateCategory.templateCategory}
              </option>
            ))}
          </select>
        </div>

          <button type="button"  onClick={() => applyFilters(0)}>Apply Filters</button>
          <button type="button" onClick={resetFilters}> Reset Filters</button>

        </div>

        {canManageWhatsAppSetup && (
          <div className="action-bar">
            <button onClick={() => handleCreateNew()}>+ Create New</button>

            <button type="button" onClick={refreshCache}>
              Refresh Cache
            </button>
          </div>
        )}

        {createMessage && (
          <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", color: "#15803d", padding: "6px 10px", borderRadius: "6px", marginTop: "6px", fontSize: "12px" }}>
            {createMessage}
          </div>
        )}

        {createError && (
          <div style={{ background: "#fef2f2", border: "1px solid #fecaca", color: "#b91c1c", padding: "6px 10px", borderRadius: "6px", marginTop: "6px", fontSize: "12px" }}>
            {createError}
          </div>
        )}

        {/* <button onClick={() => setModalOpen(true)}>+ Create New</button> */}

        {/* Manual Modal Implementation */}

        {modalOpen && (
          <div className="modal-overlay">
            <div className="modal wa-popup">

              <div className="modal-header">
                {/* <h3>Create New WhatsApp Template</h3> */}
                <h3>{viewMode === 'create' ? 'Create Template' : 'Edit Template'}</h3>
                {/* Standard "X" Close Button 
                <button className="close-btn" onClick={() => setModalOpen(false)}>×</button>*/}
              </div>
              {formError && Object.values(formError).some(val => val !== null && val !== undefined && val !== "") && (
                <div style={{ background: "#fef2f2", border: "1px solid #fecaca", color: "#b91c1c", padding: "12px", borderRadius: "6px", margin: "0 20px 8px", flex: "0 0 auto", maxHeight: "30%", overflow: "auto" }}>
                  <strong>Please fix the following errors:</strong>
                  <ul style={{ margin: "8px 0 0 20px" }}>
                    {Object.entries(formError)
                      .filter(([_, val]) => val !== null && val !== undefined && val !== "")
                      .map(([key, err], index) => (
                        <li key={index}>
                          {typeof err === "object" ? JSON.stringify(err) : String(err)}
                        </li>
                      ))}
                  </ul>
                </div>
              )}

              <div className="modal-body">
                <form id="templateForm" onSubmit={handleSubmit}>
                  {/* ===== Basic Info ===== */}
                  <input
                    placeholder="Template Name (e.g. order_confirmation_1)"
                    value={templateForm.name}
                    onChange={(e) => {
                      // WhatsApp template names allow only lowercase letters, numbers and underscores
                      const sanitized = e.target.value
                        .toLowerCase()
                        .replace(/\s+/g, "_")
                        .replace(/[^a-z0-9_]/g, "");
                      setTemplateForm({ ...templateForm, name: sanitized });
                    }}
                    readOnly={viewMode === "edit"}
                    style={{
                      marginBottom: "4px",
                      backgroundColor:
                        viewMode === "edit" ? "#f3f4f6" : "white",
                      cursor:
                        viewMode === "edit" ? "not-allowed" : "text"
                    }}
                    required
                  />
                  {viewMode === "create" && (
                    <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "12px" }}>
                      Lowercase letters, numbers and underscores only. No spaces or special characters.
                    </div>
                  )}


                  <select
                    name="categoryId"
                    value={templateForm.category}
                    onChange={(e) => setTemplateForm({ ...templateForm, category: e.target.value })}
                    disabled={viewMode === "edit"}
                    style={{
                      marginBottom: "12px",
                      backgroundColor:
                        viewMode === "edit" ? "#f3f4f6" : "white",
                      cursor:
                        viewMode === "edit" ? "not-allowed" : "pointer"
                    }}
                    required
                  >
                    <option value="">Select a category</option>
                    {categories.map((category) => (
                      <option key={category.templateCategory} value={category.templateCategory}>
                        {category.templateCategory}
                      </option>
                    ))}
                  </select>

                  <select
                    name="wabaId"
                    value={templateForm.wabaId != null ? String(templateForm.wabaId) : ""}
                    onChange={(e) => setTemplateForm({ ...templateForm, wabaId: e.target.value })}
                    style={{ marginBottom: "12px" }}
                    required
                  >
                    <option value="">Select a WABA</option>
                    {wabas.map((waba) => (
                      <option key={waba.id} value={String(waba.wabaId)}>
                        {waba.wabaId}
                      </option>
                    ))}
                  </select>

                  {/* ===== Header ===== */}
                  <h4>Header</h4>

                    <select
                      value={templateForm.components[0].format}
                      onChange={(e) => updateComponent(0, "format", e.target.value)}
                      style={{ marginBottom: "12px" }}
                    >
                      <option value="">--Select One--</option>
                      <option value="TEXT">TEXT</option>
                      <option value="IMAGE">IMAGE</option>
                      <option value="VIDEO">VIDEO</option>
                      <option value="DOCUMENT">DOCUMENT</option>
                      <option value="LOCATION">LOCATION</option>
                    </select>

                    {/* Show only for TEXT format */}
                    {templateForm.components[0].format === "TEXT" && (
                      <>
                        <input
                          placeholder="Header Text"
                          value={templateForm.components[0].text}
                          onChange={(e) => updateComponent(0, "text", e.target.value)}
                        />

                        {/* Show button only if no variable exists */}
                        {(templateForm.components[0].example?.header_text ?? []).length === 0 && (
                          <button
                            type="button"
                            onClick={addHeaderText}
                            style={{ marginTop: "12px" }}
                          >
                            + Add Header Variable
                          </button>
                        )}

                        {(templateForm.components[0].example?.header_text ?? []).map((v, i) => (
                          <div key={i} className="inline">
                            <input
                              placeholder="Header Variable"
                              value={v}
                              onChange={(e) => updateHeaderText(i, e.target.value)}
                            />

                            <button
                              type="button"
                              onClick={() => deleteHeaderText(i)}
                            >
                              ❌
                            </button>
                          </div>
                        ))}
                      </>
                    )}

                  {/* ===== Body ===== */}
                  <h4>Body</h4>
                  <textarea
                    placeholder="Body Text"
                    value={templateForm.components[1].text}
                    onChange={(e) => updateComponent(1, "text", e.target.value)}
                     style={{
                      border: "1px solid #d1d5db",
                      borderRadius: "4px",
                      padding: "8px"
                    }}
                    required
                  />

                  <button type="button" onClick={addBodyText} style={{ marginTop: '12px' }}>+ Add Body Variable</button>

                  {(templateForm.components[1].example?.body_text?.[0] ?? []).map((v, i) => (
                    <div key={i} className="inline">
                      <input
                        placeholder={`Body variable ${i + 1}`}
                        value={v}
                        onChange={(e) => updateBodyText(i, e.target.value)}
                      />
                      <button type="button" onClick={() => deleteBodyText(i)}>❌</button>
                    </div>
                  ))}

                  {/* ===== Footer ===== */}
                  <h4>Footer</h4>
                  <input
                    placeholder="Footer Text"
                    value={templateForm.components[2].text}
                    onChange={(e) => updateComponent(2, "text", e.target.value)}
                  />

                  {/* ===== Buttons ===== */}
                  <h4>Buttons</h4>
                 <button
                  type="button"
                  onClick={addButton}
                  disabled={(templateForm.components[3]?.buttons ?? []).length >= 10}
                  style={{ marginBottom: "12px" }}
                >
                  + Add Button
                </button>

                  {(templateForm.components[3]?.buttons ?? []).map((btn, i) => (
                    <div key={i} className="action-buttons">
                      <select
                        value={btn.type}
                        onChange={(e) => updateButton(i, "type", e.target.value)}
                      >
                        <option value="">Select Type</option>

                        <option
                          value="OTP"
                          disabled={
                            templateForm.components[3].buttons.filter(
                              (b, idx) => idx !== i && b.type === "OTP"
                            ).length >= 1
                          }
                        >
                          OTP
                        </option>

                        <option
                          value="PHONE_NUMBER"
                          disabled={
                            templateForm.components[3].buttons.filter(
                              (b, idx) => idx !== i && b.type === "PHONE_NUMBER"
                            ).length >= 1
                          }
                        >
                          Phone Number
                        </option>

                        <option
                          value="URL"
                          disabled={
                            templateForm.components[3].buttons.filter(
                              (b, idx) => idx !== i && b.type === "URL"
                            ).length >= 2
                          }
                        >
                          URL
                        </option>

                        <option
                          value="QUICK_REPLY"
                          disabled={
                            templateForm.components[3].buttons.filter(
                              (b, idx) => idx !== i && b.type === "QUICK_REPLY"
                            ).length >= 10
                          }
                        >
                          Quick Reply
                        </option>
                      </select>

                      <input
                        placeholder="Button Text"
                        value={btn.text}
                        onChange={(e) => updateButton(i, "text", e.target.value)}
                      />

                      {btn.type === "OTP" && (
                        <select
                          value={btn.otp_type}
                          onChange={(e) => updateButton(i, "otp_type", e.target.value)}
                        >
                          <option value="">Select OTP Type</option>
                          <option value="COPY_CODE">Copy Code</option>
                          <option value="ONE_TAP">One Tap</option>
                        </select>
                      )}

                      {btn.type === "PHONE_NUMBER" && (
                        <input
                          placeholder="Phone Number"
                          value={btn.phone_number}
                          onChange={(e) => updateButton(i, "phone_number", e.target.value)}
                        />
                      )}

                      {btn.type === "URL" && (
                        <>
                        <input
                          placeholder="https://example.com/{{1}}"
                          value={btn.url}
                          onChange={(e) =>
                            updateButton(i, "url", e.target.value)
                          }
                        />
                        <small>
                          Only one variable allowed. Example:
                          https://example.com/{"{{1}}"}
                        </small>
                      </>
                    )}
                      <button type="button" onClick={() => deleteButton(i)}>❌</button>
                    </div>
                  ))}
                </form>
              </div>

              <div className="modal-footer">
                <button type="button" onClick={() => { clearMessages(); setModalOpen(false); }}>Cancel</button>
                <button type="submit" form="templateForm">Submit</button>
              </div>
            </div>
          </div>
        )}
      <h3>Existing App Templates</h3>
      {templates.length === 0 ? (
        <p>No templates available</p>
      ) : (
        <div className="table-responsive">
          <table className="notifications-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>WA Template ID</th>
                <th>Business Account ID</th>
                <th>Template Name</th>
                <th>Template Category</th>
                <th>Quality Score</th>
                <th>Template Body</th>
                <th>Activation Status</th>
                <th>Template Stage</th>
                <th>Created At</th>
                <th>Last Updated At</th>
                <th>Last Updated By</th>
                {canManageWhatsAppSetup && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {templates.map((template) => (
                <tr key={template.id}>
                  <td>{template.id}</td>
                  <td>{template.waTemplateId}</td>
                  <td>{template.wabaId}</td>
                  <td>{template.waTemplateName}</td>
                  <td>{template.waTemplateCategory?.templateCategory}</td>
                  <td>{template.waTemplateQuality}</td>
                  <DataCell label="Template Body" value={JSON.stringify(template.waTemplate, null, 2)} onClick={setActiveDetails} />
                  <td>{template.waTemplateStatus ? 'Active' : 'Inactive'}</td>
                  <td>
                    {editingTemplate === template.id ? (
                      <select
                        value={editSmsTemplateStage}
                        onChange={(e) => setEditSmsTemplateStage(e.target.value)}
                      >
                        <option value="">Select Stage</option>
                         {[...TEMPLATE_STAGES]?.map((stage, index) => (
                        <option key={index} value={stage}>
                          {stage}
                        </option>
                      ))}
                      </select>
                    ) : (
                      // display value when not editing (you can prettify the text)
                      template.waTemplateStage || "N/A"
                    )}
                  </td>
                  <td>{new Date(template.createdTimestamp).toLocaleString()}</td>
                  <td>{new Date(template.updatedTimestamp).toLocaleString()}</td>
                  <td>{template.lastUpdatedBy}</td>

                  {canManageWhatsAppSetup && (
                    <td>
                      <div className="action-buttons">
                      {editingTemplate === template.id ? (
                        <button onClick={() => handleEditSubmit(template.id)}>Save</button> // Save edited whatsapp template
                      ) : (
                        <button onClick={() => handleEditClick(template)}>Edit</button> // Set whatsapp template
                      )}
                      <button onClick={() => toggleActivationStatus(template.id, template.waTemplateStatus)}>
                        {template.waTemplateStatus ? 'Disable' : 'Enable'}
                      </button>
                      <button
                        onClick={() => handleSyncTemplate(template)}
                        disabled={syncingTemplateId === template.id}
                      >
                        {syncingTemplateId === template.id ? 'Syncing...' : 'Sync'}
                      </button>
                      <button onClick={() => handleDeleteClick(template)}>Delete</button>
                      </div>
                      {actionErrors[template.id] && (
                        <div style={{ background: "#fef2f2", border: "1px solid #fecaca", color: "#b91c1c", padding: "6px 10px", borderRadius: "6px", marginTop: "6px", fontSize: "12px" }}>
                          {actionErrors[template.id]}
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button onClick={handlePreviousPage} disabled={page === 0}>Previous</button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={page + 1 === totalPages}>Next</button>
      </div>
      {/* ONE MODAL TO RULE THEM ALL */}
      <CommonModal
        isOpen={!!activeDetails}
        onClose={() => setActiveDetails(null)}
        /* Pull the dynamic title from state */
        title={activeDetails?.title || "Details"}
        copyValue={activeDetails?.text}
      >
        {activeDetails?.text}
      </CommonModal>

      {deleteTarget && (
        <div className="modal-overlay">
          <div className="modal" style={{ width: "90vw", maxWidth: "480px", padding: "20px" }}>
            <div className="modal-header">
              <h3>Delete Template</h3>
            </div>
            <div className="modal-body">
              <p>
                Choose how to delete template{" "}
                <strong>{deleteTarget.waTemplateName}</strong> ({deleteTarget.waTemplateId}):
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" onClick={handleDeleteCancel}>Cancel</button>
              <button
                type="button"
                onClick={handleSoftDelete}
                disabled={deletingTemplateId === deleteTarget.id}
              >
                Soft-Delete in DB only
              </button>
              <button
                type="button"
                onClick={handleHardDelete}
                disabled={deletingTemplateId === deleteTarget.id}
              >
                Hard Delete in app &amp; soft-delete in DB
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

};

export default WaTemplatePage;
